// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Header_headerWrapper__Vqqwj","name":"Header_name__38InR","logo":"Header_logo__3T0lc","headerDesktopWrapper":"Header_headerDesktopWrapper__2DHZP"};